import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image.tsx";
import Login from "components/Structure/Login/Login";
import { useContent } from "contexts/contentContext/contentContext";
import { useMail } from "contexts/mailContext/mailContext";
import { useModal } from "contexts/modalContext/modalContext";
import { useUser } from "contexts/userContext/userContext";
import useMediaQueries from "hooks/useMediaQueries";
import { useSaveAction } from "hooks/useSaveAction";
import { useState, useEffect } from "react";
import GetTransformedDate from "utils/dateViewTransformer";

const TimerElement = () => {
  const { getMailMetaData } = useMail();
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const { isLoggedIn, isSubscribed } = useUser();

  const { handleClick, loading, isSavedByCurrentUser } = useSaveAction();
  const { mobileCondition } = useMediaQueries();
  const handleSaveClick = () => {
    if (!isLoggedIn()) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
      return;
    }
    handleClick();
  };

  const [timer, setTimer] = useState(0);

  useEffect(() => {
    // count time left to expiration
    const expirationDate = new Date(getMailMetaData().Expiration);

    const currentDate = new Date();
    const timeLeft = expirationDate.getTime() - currentDate.getTime();
    setTimer(timeLeft);

    const intervalId = setInterval(() => {
      setTimer((prev) => prev - 1000);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [getMailMetaData().Expiration]);

  console.log("!!!", mobileCondition, !isSubscribed());

  return (
    <div
      className={`upload-complete-sidebar-body-row ${
        isSavedByCurrentUser ? "saved-sidebar-wrap" : ""
      }`}
    >
      <div className="info">
        <div className="info-title">
          {getTextByKey("sidebar-info-expirationdate")}:
        </div>
        <div className="info-value">
          {isSavedByCurrentUser ? null : (
            <>
              <GetTransformedDate
                date={getMailMetaData().Expiration}
                fullView={true}
                showDay={false}
                showTime={false}
              />
            </>
          )}
        </div>
      </div>
      <div
        className={`upload-complete-btn-wrap ${
          isSavedByCurrentUser ? "is-saved" : ""
        }`}
      >
        {isSavedByCurrentUser && (
          <div className="action saved-btn-wrap">
            <Icon name="saved" green />
            {getTextByKey("mail-has-no-expiration-text")}
          </div>
        )}
        <div
          className={`action ${
            isSubscribed() && !mobileCondition ? "is-susbscribed-save-btn" : ""
          } `}
          onClick={handleSaveClick}
        >
          {loading ? (
            <Image name="preloader" ext="gif" alt="loading" />
          ) : (
            <>
              <Icon
                name={
                  isSavedByCurrentUser
                    ? "unsave"
                    : isSubscribed()
                    ? "save"
                    : "jm-marketing-icon"
                }
                {...(mobileCondition && isSubscribed()
                  ? { gray: true }
                  : isSavedByCurrentUser || isSubscribed()
                  ? { blue: true }
                  : {})}
              />
              {!mobileCondition
                ? getTextByKey(
                    isSavedByCurrentUser
                      ? "confirm-unsave-mail-button-yes"
                      : isSubscribed()
                      ? "save"
                      : "save-for-good"
                  )
                : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TimerElement;
